import type { MultiselectProps } from '@risk-smart/themed-cloudscape-components/multiselect';
import CSMultiSelect from '@risk-smart/themed-cloudscape-components/multiselect';
import { forwardRef } from 'react';

import { useVisibleOptions } from '../option-label-filter/useVisibleOptions';
import styles from './style.module.scss';

const Multiselect = forwardRef<MultiselectProps.Ref, MultiselectProps>(
  ({ filteringType = 'auto', options, onLoadItems, ...props }, ref) => {
    // See filterOptionsByVisibleText for why we override 'auto' filtering.
    const preFilter = filteringType === 'auto';
    const { visibleOptions, setFilteringText } = useVisibleOptions(
      options,
      preFilter
    );

    // Do NOT suppress the caller's `virtualScroll` on the pre-filtered path —
    // see the comment in ../select/Select.tsx, which this wrapper mirrors. Two
    // attempts have now done that (RSP-6288, then COI-569's first fix) and both
    // produced the same outage from opposite ends: an un-virtualised list of one
    // Option component per row, first on open and then on every keystroke.

    return (
      <div className={styles.select}>
        <CSMultiSelect
          {...props}
          filteringType={preFilter ? 'manual' : filteringType}
          options={visibleOptions}
          onLoadItems={(event) => {
            if (preFilter) {
              setFilteringText(event.detail.filteringText ?? '');
            }
            onLoadItems?.(event);
          }}
          ref={ref}
        />
      </div>
    );
  }
);
Multiselect.displayName = 'Multiselect';

export default Multiselect;
